<script setup lang="ts">
  import type { SupportSession } from '@gat-ship/types'
  import { globalUtils } from '@gat-ship/utils'
  import { ref } from 'vue'
  import { Button } from '@gat-ship/vue-components'
  import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
  } from '@gat-ship/vue-components'
  import { useSupportSessionContext } from '../../composables/useSupportSession'

  const supportSessionService = useSupportSessionContext()!

  const supportSession = ref<SupportSession | undefined>(undefined)

  const showEndSupportSessionModal = ref(false)

  export type ShowEndSupportSessionDialogParams = {
    supportSession: SupportSession
  }

  function showModal({
    supportSession: session
  }: ShowEndSupportSessionDialogParams) {
    supportSession.value = session
    showEndSupportSessionModal.value = true
  }

  async function onEndSupportSession() {
    if (supportSession.value?.sessionId) {
      await supportSessionService.commands.endSupportSession(
        supportSession.value.sessionId,
        globalUtils.functions.uuid()
      )
      showEndSupportSessionModal.value = false
    }
  }

  defineExpose({
    showModal
  })
</script>

<template>
  <AlertDialog v-model:open="showEndSupportSessionModal">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>End Support Session</AlertDialogTitle>
      </AlertDialogHeader>
      <div class="flex flex-col gap-4 text-sm leading-none">
        <span>Are you sure you want to end the support session?</span>
        <span>
          Gatship support will no longer be able to access your tenant through
          this session.
        </span>
      </div>
      <AlertDialogFooter>
        <Button variant="outline" size="lg" @click="onEndSupportSession()">
          End Support Session
        </Button>
        <Button
          variant="ghost"
          size="lg"
          @click="showEndSupportSessionModal = false"
        >
          Cancel
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
